/** Wait a set amount of time before resolving the promise. */
export function wait(timeInMs: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, timeInMs);
  });
}
